import React, { useState, useEffect } from 'react';
import api from '../services/api';
import {
  Box, TextField, Button, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Paper, IconButton, Alert, CircularProgress,
  Dialog, DialogTitle, DialogContent, DialogActions
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';

function ManutencaoLocalManager() {
  const [locais, setLocais] = useState([]);
  const [nome, setNome] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);

  const fetchLocais = () => {
    setLoading(true);
    api.get('/manutencao-locais')
      .then((response) => setLocais(response.data || []))
      .catch((err) => {
        console.error('Erro ao buscar locais de manutenção:', err);
        setError('Não foi possível carregar os locais de manutenção.');
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchLocais();
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!nome.trim() || submitting) return;
    setSubmitting(true);
    setError('');

    const request = editingId
      ? api.put(`/manutencao-locais/${editingId}`, { nome: nome.trim() })
      : api.post('/manutencao-locais', { nome: nome.trim() });

    request
      .then(() => {
        setNome('');
        setEditingId(null);
        setDialogOpen(false);
        fetchLocais();
      })
      .catch((err) => {
        console.error('Erro ao salvar local:', err);
        setError(err.response?.data || 'Erro ao salvar local.');
      })
      .finally(() => setSubmitting(false));
  };

  const handleEdit = (local) => {
    setEditingId(local.id);
    setNome(local.nome);
    setDialogOpen(true);
  };

  const handleDelete = (id) => {
    if (!window.confirm('Tem certeza que deseja deletar este local?')) return;
    api.delete(`/manutencao-locais/${id}`)
      .then(() => fetchLocais())
      .catch((err) => {
        console.error('Erro ao deletar local:', err);
        setError(err.response?.data || 'Erro ao deletar local.');
      });
  };

  const handleCancelEdit = () => {
    setEditingId(null);
    setNome('');
    setDialogOpen(false);
  };

  const handleNew = () => {
    handleCancelEdit();
    setDialogOpen(true);
  };

  return (
    <Box>
      {error && <Alert severity="error" onClose={() => setError('')} sx={{ mb: 2 }}>{error}</Alert>}

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
        <Button variant="contained" startIcon={<AddIcon />} onClick={handleNew}>
          Novo local
        </Button>
      </Box>

      <Dialog open={dialogOpen} onClose={handleCancelEdit} fullWidth maxWidth="sm">
        <Box component="form" onSubmit={handleSubmit}>
          <DialogTitle>{editingId ? 'Editar Local' : 'Cadastro de Local'}</DialogTitle>
          <DialogContent>
          <TextField
            label="Nome (descrição do local)"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            fullWidth
            required
            placeholder="Ex.: Portaria, Lixeira, Área comum"
            margin="dense"
          />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCancelEdit} disabled={submitting}>Cancelar</Button>
            <Button type="submit" variant="contained" disabled={submitting}>
              {submitting ? <CircularProgress size={20} color="inherit" /> : 'Salvar'}
            </Button>
          </DialogActions>
        </Box>
      </Dialog>

      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Local</TableCell>
              <TableCell align="right">Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow><TableCell colSpan={2} align="center"><CircularProgress size={24} /></TableCell></TableRow>
            ) : locais.length === 0 ? (
              <TableRow><TableCell colSpan={2} align="center">Nenhum local cadastrado.</TableCell></TableRow>
            ) : locais.map((local) => (
              <TableRow key={local.id}>
                <TableCell>{local.nome}</TableCell>
                <TableCell align="right">
                  <IconButton size="small" aria-label="editar" onClick={() => handleEdit(local)}>
                    <EditIcon fontSize="small" />
                  </IconButton>
                  <IconButton size="small" aria-label="deletar" onClick={() => handleDelete(local.id)}>
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default ManutencaoLocalManager;
